<template>
  <v-container>
    <div id="chart-container">
      <v-row align="center">
        <v-col style="">
          <v-autocomplete
            class="graph-selector"
            :items="chartList"
            label="Gráfico"
            v-model="selectedChart"
            @change="updateGraph"
          ></v-autocomplete>
          <v-row>
            <div v-if="loading">
              <v-progress-circular
                indeterminate
                class="loading"
                color="primary"
              >
                Cargando
              </v-progress-circular>
            </div>
            <v-chart class="chart" :option="options" />
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { getcounters } from "@/utils/apiRequest";
import { getCountInData, setupGraph } from "@/utils/utils";
// getCookie
export default {
  data() {
    return {
      //
      loading: true,
      formsCount: 0,
      rejectedCount: 0,
      approvedCount: 0,
      publishedCount: 0,
      sectorsCount: new Map(),
      domainsCount: new Map(),
      subDomainsCount: new Map(),
      institutionsCount: new Map(),
      selectedChart: "dominios",
      //
      chartList: [],
      combinations: new Map(),
      options: {},
    };
  },
  methods: {
    updateGraph(value) {
      getCountInData(this, value);
      let data = this.combinations.get(value);

      this.options = data;
    },
  },
  watch: {},

  async mounted() {
    let response = await getcounters();
    if (response.status == 200) {
      this.formsCount = response.data.totalCount;
      this.rejectedCount = response.data.rejected;
      this.approvedCount = response.data.approved;
      this.sectorsCount = Object.entries(response.data.sectors);
      this.domainsCount = Object.entries(response.data.domains);
      this.subDomainsCount = Object.entries(response.data.subdomains);
      this.institutionsCount = Object.entries(response.data.organizations);
      this.publishedCount = response.data.published;
      setupGraph(this, "intern");
      this.updateGraph("dominios");
    }
    this.loading = false;
  },
};
</script>

<style scoped>
.loading {
  position: absolute;
  left: 50%;
  margin: 15% 0 0 0;
}
#chart-container {
  width: 100%;
  height: 31rem;
}

.chart {
  margin: 0 0 0 2.5%;
  width: 100%;
  height: 50rem;
}

.graph-selector {
  max-width: 80%;
  margin: 0 0 0 10%;
}
</style>